import React from "react";
import { Reveal } from "./Reveal";

export function PageHeader({ overline, title, subtitle, children }) {
  return (
    <section className="pt-36 pb-12 md:pt-44 md:pb-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl">
          {overline && (
            <span className="text-xs uppercase tracking-[0.2em] text-[#5C6664]">{overline}</span>
          )}
          <h1 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-ink leading-[1.05]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-5 text-base md:text-lg text-[#5C6664] font-light leading-relaxed">
              {subtitle}
            </p>
          )}
          {children}
        </Reveal>
      </div>
    </section>
  );
}
